
export default defineNuxtPlugin( async (app) => {

    const { AppCookieNames } = await import("~/assets/constants/ecomApi");

    const jwtData = useState(AppCookieNames.CustomerJWT)
    const authData = useState('authUser')
    const authStore = useAuthStore();
    const rootStore = useRootStore();

    if(jwtData.value && authData.value){
        authStore.user = rootStore.clone(authData.value);
        return false;
    }

    const auth_token = useCookie(AppCookieNames.CustomerJWT);
    if(!auth_token.value || !auth_token.value.value){
        authStore.user = null;
        return false;
    }

    jwtData.value =  rootStore.clone(auth_token.value);

    const response = await authStore.setAuthUserByToken(auth_token.value.value);

    authData.value = null;
    if (response && response.id) {
        authStore.user = rootStore.clone(response);
        authData.value = rootStore.clone(response);
    }
});